import React, { FC } from 'react'
import s from './Footer.module.scss'
import { ReactComponent as Logo } from './../../assets/icons/logoFooter.svg'
import { FaPhone, FaEnvelope, FaTelegram, FaWhatsapp } from 'react-icons/fa';
import { ReactComponent as MaxIcon } from './../../assets/icons/maxIcon.svg';
import { Link } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';

const Footer: FC = () => {
    const { info } = useAppSelector(state => state.info)

    return (
        <footer className={s.footer}>
            <div className={s.logo}><Logo /></div>
            <div className={s.contacts}>
                <div>
                    <a rel="noreferrer noopener" href={`mailto:${info?.contacts?.email}`}>{React.createElement(FaEnvelope as any)}{info?.contacts?.email}</a>
                    <a rel="noreferrer noopener" href={`tel:${info?.contacts?.phone}`}>{React.createElement(FaPhone as any)}{info?.contacts?.phone}</a>
                </div>
                <div>
                    <span>{info?.contacts?.inn}</span>
                    <span>{info?.contacts?.address}</span>
                </div>
            </div>
            <div className={`${s.box_copyright} container`}>
                <div>
                    <ul>
                        <li><a target='_blank' rel="noreferrer noopener" href={`${info?.contacts?.telegram}`}>{React.createElement(FaTelegram as any)}</a></li>
                        <li><a target='_blank' rel="noreferrer noopener" href={`${info?.contacts?.whatsapp}`}>{React.createElement(FaWhatsapp as any)}</a></li>
                        {info?.contacts?.vk && (
                            <li>
                                <a target='_blank' rel="noreferrer noopener" href={`${info?.contacts?.vk}`}>
                                    {React.createElement(MaxIcon as any)}
                                </a>
                            </li>
                        )}
                    </ul>
                    <Link className={s.privacypolice} to={'/privacy-policy'}>Политика конфиденциальности</Link>
                </div>
                <p className={s.copyright}>{info?.contacts?.copyright}</p>
            </div>
        </footer>
    )
}

export default Footer